import { definePreset } from '@primevue/themes';

import Aura from '@primevue/themes/aura';
import PrimeVue from 'primevue/config';
import type { App } from 'vue';

const GetWhyPreset = definePreset(Aura, {
  primitive: {
    getwhy: {
      '50': '#fff3fb', // custom
      '100': '#ffe9f7',
      '200': '#ffc1eb',
      '300': '#d873ae',
      '400': '#c3498e', // custom
      '500': '#8e2560', // original: 6c66ee
      '600': '#781b50',
      '700': '#2e4747',
      '800': '#7e184c',
      '900': '#1a2f2f',
      '950': '#6b0f3e',
    },
    // getwhyTeal: { // TEAL palette
    //   '50': '#ecefef',
    //   '100': '#dee4e4',
    //   '200': '#ccd5d5',
    //   '300': '#b4c1c1',
    //   '400': '#7c9494',
    //   '500': '#405e5e', // original: 6c66ee
    //   '600': '#5b49e2',
    //   '700': '#2e4747',
    //   '800': '#4032a1',
    //   '900': '#1a2f2f',
    //   '950': '#221c4a',
    // },
  },
  semantic: {
    primary: {
      50: '{getwhy.50}',
      100: '{getwhy.100}',
      200: '{getwhy.200}',
      300: '{getwhy.300}',
      400: '{getwhy.400}',
      500: '{getwhy.500}',
      600: '{getwhy.600}',
      700: '{getwhy.700}',
      800: '{getwhy.800}',
      900: '{getwhy.900}',
      950: '{getwhy.950}',
    }, // override in assets/base.css
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '{stone.50}',
          100: '{stone.100}',
          200: '{stone.200}',
          300: '{stone.300}',
          400: '{stone.400}',
          500: '{stone.500}',
          600: '{stone.600}',
          700: '{stone.700}',
          800: '{stone.800}',
          900: '{stone.900}',
          950: '{stone.950}',
        },
      },
    },
  },
  components: {
    datatable: {
      colorScheme: {
        light: {
          header: {
            cell: {
              background: '{surface.50}',
              borderColor: '{surface.100}',
            },
          },
        },
      },
    },
  },
});

export const setupPrimeVueTheme = (app: App<Element>) => {
  app.use(PrimeVue, {
    theme: {
      preset: GetWhyPreset,
      options: {
        // https://primevue.org/theming/styled/#definepreset
        prefix: 'p',
        darkModeSelector: false, // default: 'system',
        cssLayer: {
          // default: false
          name: 'primevue',
          order: 'theme, base, primevue'
          // old: order: 'tailwind-base, primevue, tailwind-utilities',
        },
      },
    },
  });
};
